import React from "react";
import GridItem from "../../../../Components//UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useLocation } from "react-router-dom";
import RoleRegistrationForm from "./RoleRegistrationForm";
import { useTranslation } from "react-i18next";

// Component for creating or editing a role
const CreateRole = () => {
  // Initialize translation hook for internationalization
  const { t } = useTranslation();

  // Get location state to check if this is an edit operation
  const { state } = useLocation();
  let edit = state?.edit;

  // Define grid layout configuration for the page components
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      // Header component with dynamic title based on edit mode
      component: (
        <DMSHeader
          title={
            edit
              ? t("Edit Role Details")
              : t("createrole_management_formheader")
          }
          showIconsForback={true}
        />
      ),
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 11,
      id: 2,
      // Main form component for role creation/editing
      component: <RoleRegistrationForm />,
    },
  ];

  // Render the grid layout with configured components
  return (
    <div className="grid-stack grid-stack-instance-1 ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default CreateRole;
